import { render, staticRenderFns } from "./test-signature.vue?vue&type=template&id=1731f951&scoped=true&"
import script from "./test-signature.vue?vue&type=script&lang=js&"
export * from "./test-signature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1731f951",
  null
  
)

export default component.exports